import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { convertToDecimals, currency } from '@pharmaplan/common';

import ServiceCard from '../../SelfService/ServiceCard';
import strings from '../../../localization';

import styles from './styles';

interface ITotalContractValue {
  days: number;
  value: number;
}

const TotalContractValue: FC<ITotalContractValue> = ({ days, value }) =>
  (
    <ServiceCard
      customContainerStyle={styles.padTop}
      content={(
        <Box sx={styles.contractValueContainer}>
          <Typography sx={styles.contractValueNote}>
            {`${strings.totalContractValue} (${days} ${
              days > 1 ? strings.days.toLowerCase() : strings.day.toLowerCase()
            })`}
          </Typography>
          <Typography sx={styles.contractValueNote}>
            {`${currency}${convertToDecimals(value)}`}
          </Typography>
        </Box>
    )}
    />
  );

export default TotalContractValue;
